import Loader from '@components/framework/loader/Loader';
import React from 'react';

const ImportLoader = (): React.ReactElement => {
  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center'
      }}>
      <Loader style={{color: 'blue'}} color={'secondary'} size={16} />
    </div>
  );
};
export default ImportLoader;
